import React, { useState } from 'react';
import logo from '../assets/logo.jpeg';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        
        <Link to="/" className="nav-logo">
          <img src={logo} alt="OneYard Systems Logo" className="nav-logo-img" />
        </Link>

        {/* Hamburger Button */}
        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </div>

        {/* Menu */}
        <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/services" className="nav-link" onClick={() => setMenuOpen(false)}>Services</Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>About</Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link nav-link-btn" onClick={() => setMenuOpen(false)}>
              Contact Us
            </Link>
          </li>
        </ul>

      </div>
    </nav>
  );
}

export default Navbar;